export default "__VITE_ASSET__CCGa6ctr__"